import { useSyncExternalStore, useCallback } from "react";

export const MOBILE_QUERY = "(max-width: 720px)";
export const COMPACT_SHELL_QUERY = "(max-width: 1280px)";

export default function useMediaQuery(query) {
  const subscribe = useCallback((notify) => {
    const media = window.matchMedia(query);
    media.addEventListener("change", notify);
    return () => media.removeEventListener("change", notify);
  }, [query]);
  const snapshot = useCallback(() => typeof window !== "undefined" && window.matchMedia(query).matches, [query]);
  return useSyncExternalStore(subscribe, snapshot, () => false);
}
